﻿import $ from "jquery";

const validators = {
    timeat: {
        parameters: ["min", "max"],
        isValid: function (value, _element, params) {
            if (!value) {
                return true;
            }

            var typedValue = parseInt(value, 10);
            if (isNaN(typedValue)) {
                return false;
            }

            var hasMin = params.min !== undefined && params.min !== null && params.min !== "";
            var hasMax = params.max !== undefined && params.max !== null && params.max !== "";

            if (hasMin && typedValue < parseInt(params.min, 10)) {
                return false;
            }

            if (hasMax && typedValue > parseInt(params.max, 10)) {
                return false;
            }

            return true;
        },
        unpack: function (options) {
            options.rules["timeat"] = options.params;
            options.messages["timeat"] = options.message;
        }
    }
};

function setupTimeAt(parentSelector) {
    var dataTimeAt = $('[data-time-at="true"]');

    if (parentSelector) {
        dataTimeAt = $(parentSelector).find('[data-time-at="true"]');
    }

    dataTimeAt.each(function (_i, x) {
        var id = '#' + x.id;
        var format = $(id).attr('data-time-at-format') ?? 'date';
        $(id).attr('data-val-always', 'true');
        $(id).attr('data-val-focus-in', `${id}_Year`);
        $(id + '_Month, ' + id + '_Year')
            .on('blur', setTimeAt(id, true, format))
            .attr('data-evt-tracking', 'false');

        $(id + '_Month').on('change', setTimeAt(id, false, format));
        $(id + '_Year').on('input', setTimeAt(id, false, format));
        var timeAt = $(id).val();
        var startDate = new Date();

        if (timeAt) {
            if (format == "date") {
                startDate.setMonth(startDate.getMonth() - parseInt(timeAt, 10));
                $(id + '_Month').val(startDate.getMonth() + 1);
                $(id + '_Year').val(startDate.getFullYear());
            }
            else if (format == "number") {
                $(id + '_Year').val(Math.floor(timeAt / 12));
                $(id + '_Month').val(timeAt % 12);
            }
        }
    });
}

function valid(month, yearRequired, year) {
    return month && (!yearRequired || year);
}

function calculateNumberOfMonths(year, month, format, yearRequired) {
    if (!valid(month, yearRequired, year)) {
        return null;
    }

    switch (format) {
        case "number":
            return parseInt(year || 0, 10) * 12 + parseInt(month, 10);
        case "date":
            var currentTime = new Date();
            return (currentTime.getFullYear() - parseInt(year, 10)) * 12 + (currentTime.getMonth() - parseInt(month, 10) + 1);
        default:
            throw `Format ${format} not supported.`;
    }
}

function setTimeAt(field, blur, format) {
    return function () {
        var monthInput = $(field + '_Month');
        var yearInput = $(field + '_Year');
        var month = monthInput.val();
        var year = yearInput.val();
        var yearRequired = format == "date";
        var numberOfMonths = calculateNumberOfMonths(year, month, format, yearRequired);

        if (numberOfMonths != null) {
            $(field).val(numberOfMonths);

            if (!blur) {
                $(field).trigger('input');
            }
        } else {
            $(field).val("");
        }

        var validate = $(this.form).validate();
        if (valid(validate.invalid.hasOwnProperty(monthInput.attr('name')),
            yearRequired,
            validate.invalid.hasOwnProperty(yearInput.attr('name')))) {
            $(field).valid();
        }

        if (blur) {
            $(field).trigger('blur');
        }
    }
}

export { setupTimeAt, validators };
